import React from "react";
import Img from "react-image";

import images00001 from "../assets/click/images00001.png";
import images00002 from "../assets/click/images00002.png";
import images00003 from "../assets/click/images00003.png";
import images00004 from "../assets/click/images00004.png";
import images00005 from "../assets/click/images00005.png";
import images00006 from "../assets/click/images00006.png";
import images00007 from "../assets/click/images00007.jpg";
import images00008 from "../assets/click/images00008.jpg";
import images00009 from "../assets/click/images00009.jpg";
import images00010 from "../assets/click/images00010.png";
import images00011 from "../assets/click/images00011.jpg";
import images00012 from "../assets/click/images00012.jpg";
import images00013 from "../assets/click/images00013.png";
import images00014 from "../assets/click/images00014.png";
import images00015 from "../assets/click/images00015.png";
import images00016 from "../assets/click/images00016.png";
import images00017 from "../assets/click/images00017.png";
import images00018 from "../assets/click/images00018.png";
import images00019 from "../assets/click/images00019.png";
import images00020 from "../assets/click/images00020.png";
import images00021 from "../assets/click/images00021.png";
import images00022 from "../assets/click/images00022.png";
import images00023 from "../assets/click/images00023.png";
import images00024 from "../assets/click/images00024.jpg";
import images00025 from "../assets/click/images00025.jpg";
import images00026 from "../assets/click/images00026.jpg";
import images00027 from "../assets/click/images00027.jpg";
import images00028 from "../assets/click/images00028.jpg";
import images00029 from "../assets/click/images00029.jpg";
import images00030 from "../assets/click/images00030.jpg";
import images00031 from "../assets/click/images00031.jpg";
import images00032 from "../assets/click/images00032.jpg";
import images00033 from "../assets/click/images00033.jpg";
import images00034 from "../assets/click/images00034.jpg";
import images00035 from "../assets/click/images00035.jpg";
import images00036 from "../assets/click/images00036.jpg";
import images00037 from "../assets/click/images00037.jpg";
import images00038 from "../assets/click/images00038.jpg";
import images00039 from "../assets/click/images00039.jpg";
import images00040 from "../assets/click/images00040.jpg";
import images00041 from "../assets/click/images00041.jpg";
import images00042 from "../assets/click/images00042.jpg";
import images00043 from "../assets/click/images00043.jpg";
import images00044 from "../assets/click/images00044.png";
import images00045 from "../assets/click/images00045.png";
import images00046 from "../assets/click/images00046.png";
import images00047 from "../assets/click/images00047.png";
import images00048 from "../assets/click/images00048.png";

class RandomImages extends React.Component {
  images = [
    images00001,
    images00002,
    images00003,
    images00004,
    images00005,
    images00006,
    images00007,
    images00008,
    images00009,
    images00010,
    images00011,
    images00012,
    images00013,
    images00014,
    images00015,
    images00016,
    images00017,
    images00018,
    images00019,
    images00020,
    images00021,
    images00022,
    images00023,
    images00024,
    images00025,
    images00026,
    images00027,
    images00028,
    images00029,
    images00030,
    images00031,
    images00032,
    images00033,
    images00034,
    images00035,
    images00036,
    images00037,
    images00038,
    images00039,
    images00040,
    images00041,
    images00042,
    images00043,
    images00044,
    images00045,
    images00046,
    images00047,
    images00048
  ];
  state = {
    visibleImages: []
  };

  refill() {
    this.images = [
      images00001,
      images00002,
      images00003,
      images00003,
      images00005,
      images00006,
      images00007,
      images00008,
      images00010,
      images00014,
      images00015,
      images00016,
      images00017,
      images00018,
      images00019,
      images00020,
      images00021,
      images00022,
      images00024,
      images00025,
      images00026,
      images00027,
      images00028,
      images00029,
      images00030,
      images00031,
      images00032,
      images00033,
      images00034,
      images00035,
      images00036,
      images00037,
      images00038,
      images00039,
      images00040,
      images00041,
      images00042,
      images00043,
      images00044,
      images00045,
      images00046,
      images00047,
      images00048
    ];
    this.images.forEach(function(image, i, images) {
      const img = new Image();
      img.src = image;
      images[i] = img.src;
    });
  }
  componentDidMount() {
    this.images.forEach(function(image, i, images) {
      const img = new Image();
      img.src = image;
      images[i] = img.src;
    });
  }

  handleClick = e => {
    const { x, y } = e.nativeEvent;
    if (this.images.length === 0) {
      this.refill();
    }

    this.setState(prevState => ({
      visibleImages: [
        ...prevState.visibleImages,
        {
          x,
          y,
          src: this.images.splice(Math.random() * this.images.length, 1)[0]
        }
      ]
    }));
  };

  render() {
    const { visibleImages } = this.state;
    return (
      <div className="about-wrapper" onClick={e => this.handleClick(e)}>
        {this.props.children}

        {visibleImages.map(({ x, y, src }, i) => (
          <Img
            className="about-image"
            key={i}
            style={{ top: y + "px", left: x + "px" }}
            src={`${src}`}
          />
        ))}
      </div>
    );
  }
}
export default RandomImages;



// WEBPACK FOOTER //
// /opt/build/repo/src/components/randomimage.js